import React from 'react';

export default function ArrowLeft({
  strokeColor = 'white',
  strokeWidth = 1.5,
  className
}) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M10.25 6.75L4.75 12L10.25 17.25"
      ></path>
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M19.25 12H5"
      ></path>
    </svg>
  );
}